export function extractValue(val) {
  return `${val.slice(0, 3)}${val.slice(4, 6)}${val.slice(7, 11)}`;
}

export function hashedMask(ssn, showLastFour = true, showFullSSN = false) {
  const valueHidden = ssn.replace(/[\w]/g, 'X');
  if (valueHidden.length <= 3) {
    return showFullSSN ? ssn : valueHidden;
  }

  if (valueHidden.length <= 5) {
    return showFullSSN
      ? `${ssn.slice(0, 3)}-${ssn.slice(3, 5)}`
      : `${valueHidden.slice(0, 3)}-${valueHidden.slice(3, 5)}`;
  }

  if (showLastFour) {
    return showFullSSN
      ? `${ssn.slice(0, 3)}-${ssn.slice(3, 5)}-${ssn.substr(5)}`
      : `${valueHidden.slice(0, 3)}-${valueHidden.slice(3, 5)}-${ssn.substr(
          5,
        )}`;
  }
}

export function isPositiveInteger(str) {
  if (typeof str !== 'string') {
    return false;
  }

  const num = Number(str);

  if (Number.isInteger(num) && num >= 0) {
    return true;
  }

  return false;
}
